import { useCallback, useEffect, useState } from "react";

/**
 * What a read-out shows for a symbol it holds by `symbol_id` (TT-1159): its
 * catalog name. A symbol is referenced by its id everywhere; its name is only
 * shown. Returns `nameOf(symbolId)`: the name, or the id itself until the
 * catalog is read, or for a symbol it does not hold.
 *
 * `resources` is a Live Tap resource adapter (liveTap/appbackResourceAdapter):
 * its `loadSymbols()` reads the catalog once and shares it with every asker,
 * the renderer's own read-outs included. Null while the caller has no name
 * to show yet: nothing is read until it has.
 */
export default function useSymbolName(resources) {
  const [names, setNames] = useState(null);
  useEffect(() => {
    if (!resources) return undefined;
    let cancelled = false;
    resources
      .loadSymbols()
      .then((symbols) => {
        if (!cancelled) setNames(new Map(symbols.map((s) => [s.symbol_id, s.name])));
      })
      .catch((error) => console.error("[useSymbolName] the symbol catalog did not load:", error));
    return () => {
      cancelled = true;
    };
  }, [resources]);
  return useCallback((symbolId) => names?.get(symbolId) ?? symbolId, [names]);
}
